'use client';
import Image from 'next/image';
import Link from 'next/link';
import { LOGO_IMAGE } from '@/lib/constants';
import { getLogoHref } from '@/lib/logo-navigation';
import { useAuthStore } from '@/lib/store';

export default function Header() {
  const { isAuthenticated } = useAuthStore();
  const logoHref = getLogoHref(isAuthenticated);

  return (
    <header className="w-full flex items-center h-16 px-6">
      <Link href={logoHref} aria-label="Go to xDitto home">
        <div className="relative h-10 w-8">
          <Image src={LOGO_IMAGE} alt="Logo" fill className="object-contain" priority />
        </div>
      </Link>
      {/* {isAuthenticated && (
        <Button onClick={handleLogout} variant="secondarySmall" className="ml-auto">
          Logout
        </Button>
      )} */}
    </header>
  );
}
